import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingLeft: 25,
    },
    contentCard: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 10,
        marginBottom: 10,
    },
    hrLineLeft: {
        height: 0.5,
        width: '80%',
        position: 'absolute',
        borderWidth: 0.5,
        borderColor: "#8E8E93",
        right: -11,
        top: 15
    },
    hrLineRight: {
        height: 0.5,
        width: '80%',
        position: 'relative',
        borderWidth: 0.5,
        marginBottom: 10,
        borderColor: "#8E8E93",
        marginLeft: -10,
    },
    contentCoinGpx: {
        position: 'relative',
        marginVertical: 50,
        flexGrow: 1,
        marginRight: 10
    },
    textCoinGpx: {
        fontSize: 12,
        textAlign: 'right'
    },
    contentCoinBrl: {
        position: 'relative',
        marginVertical: 50,
        flexGrow: 1,
        marginLeft: 10
    },
    textCoinBrl: {
        fontSize: 12
    },
    textMyMoney: {
        position: 'absolute',
        top: 40,
        textAlign: 'center',
        fontSize: 12,
        fontWeight: '500'
    },
    contentGraphic: {
        borderWidth: 8,
        width: 120,
        borderRadius: 120,
        height: 116,
        borderColor: '#32BFB1',
        marginTop: 5,
        justifyContent: "center",
        alignItems: "center"
    },
    contentPageTab: {
        paddingHorizontal: 25
    },
    contentFilter: {
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    textFilter: {
        fontSize: 12,
        marginTop: -2
    }
});

export default styles;
